<template>
    <div class="nav" :style="navStyle">
        <div class="all">
            <div class="logo">
                <img :src="logo" alt="">
            </div>
            <div class="iconBtn" @click="jumpNav">
                <i class="iconfont icon-mobile_navigation_zhankai"></i>
            </div>
        </div>
        <div class="header-nav">
            <div class="lang-switch" v-if="isShowLangBtn">
                <div class="inner" @click="isCollased = !isCollased">
                    <span class="title">{{ lang }}</span>
                    <div :class="['tip', {active: isCollased}]">
                        <i class="iconfont icon-mobile_navigation_up" v-show="isCollased"></i>
                        <i class="iconfont icon-mobile_navigation_down" v-show="!isCollased"></i>
                    </div>
                </div>
                <div class="hr"></div>
                <div class="sub" v-show="isCollased">
                    <div class="container" v-for="(lang, index) in langOptions" :key="index">
                        <div class="inner" @click="onSwitchLanguage(lang.languageCode)">
                            <span class="sub-title">{{ lang.languageNativeName }}</span>
                        </div>
                        <div class="hr"></div>
                    </div>
                </div>
            </div>
            <nav-item 
                v-for="route in routes.data" 
                :key='route.menuId' 
                :menu="route" 
                @active="onSetActive" 
                @close="onCloseNav">
            </nav-item>
            <div class="m-btns">
                <div class="footer" v-if="isLogin">
                    <div class="m-btn primary" @click="goSystem">{{ $t('home.enter') }}</div>
                </div>
                <div class="footer" v-if="isShowLoginBtn && !isLogin">
                    <div class="m-btn" @click="goLogin">{{ $getConfigText(loginInfo.loginBtnName) }}</div>
                    <div class="m-btn primary" @click="goRegister">{{ $getConfigText(loginInfo.registerBtnName) }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .nav{
        transition: transform 0s 0.5s;
        width: 10rem;
        height: 110vh;
        background-color: rgba(0,0,0,0.39);
        z-index:999;
        position: fixed;
        left:0rem;
        top:0rem;
        .all{        
            position: fixed;
            top: 0;
            right: 0;
            display: flex;
            justify-content: space-between;    
            align-items: center;
            z-index:999;
            width: 7.89rem;
            height: 1.27rem;
            padding: 0 .53rem;
            background: #fff;
            .logo img {
                height: 0.8rem;
                max-width: 8rem;
            }
            .iconBtn {
                font-size: 0.42rem;
                vertical-align: center;
            }
        }
        .header-nav{
            position: fixed;
            top: 0;
            right: 0;
            z-index:99;
            width: 7.89rem;
            height: 100vh;
            padding: 1.27rem .53rem 3rem;
            background-color: #fff;
            overflow-y: auto;
            .lang-switch{
                display: flex;
                flex-direction: column;
                .inner{
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: space-between;
                    width: 100%;
                    height: 1.6rem;
                    .title{
                        font-size: 0.43rem;
                        line-height: 0.59rem;
                        font-weight: bold;
                        color: #1F1F1F;
                    }
                    .tip > .iconfont{
                        color: #999;
                        font-size: .18rem;
                    }
                    .tip.active > .iconfont{
                        color: var(--activeColor);
                    }
                }
                .hr{
                    width: 100%;
                    border-bottom: 1px solid #EBEBEB;
                }
                .sub{
                    padding-left: .4rem;
                    .sub-title{
                        font-size: 0.37rem;
                        font-weight: 400;
                    }
                }
            }
            .m-btns{
                display: flex;
                flex-direction: row;
                justify-content: center;
                .footer{
                    display: flex;
                    justify-content: center;
                    width: 100%;
                    padding-bottom: 0.21rem;
                    padding-top: 0.67rem;
                    .m-btn:nth-child(1){
                        margin-right: 0.32rem;
                    }
                    .m-btn{
                        width: 3.1rem;
                        height: 1.07rem;
                        line-height: 1.07rem;
                        text-align: center;
                        font-size: 0.48rem;
                        background: #fff;
                        color: var(--theme);
                        border: 1px solid var(--theme);
                        border-radius: 5px;
                    }
                    .m-btn.primary{
                        color: #fff;
                        background: var(--theme);
                        border: none;
                    }
                }
                
            }
        }
    }
</style>

<script>
import NavItem from './nav-item.vue' 
import { mapState, mapGetters } from 'vuex'
import { User } from '@/lib/user'
import { PaasTenant } from '@/models/paas-tenant'
import { Login } from '@/models/login'
import { Header } from '@/models/header.js'
import { Language } from '@/lib/util/language.js'
import { LanguageContent } from '@/lib/util/lang.js'
export default {
    name:'NavList',
    props:{
        routes:Object,
    },
    components:{
        NavItem,
    },
    data() {
        return {
            ShowNav: false,
            isLogin: false,
            isCollased: false
        }
    },
    computed: {
        ...mapState({
            logo: 'logo',
            loginInfo: 'loginInfo',
            baseInfo: 'baseInfoM'
        }),
        ...mapGetters(['isShowLoginBtn']),
        isShowLangBtn(){
            return Language.getConfig().isLanguageSwitcher === 1 ? true : false
        },
        langOptions(){
            return Language.getList()
        },
        lang(){
            const lang = this.langOptions.find(lang => lang.languageCode === this.$i18n.locale)
            if(lang){
                return lang.languageNativeName
            }
            if(this.$i18n.locale === 'zh_CN') return '简体中文'
            if(this.$i18n.locale === 'zh_TW') return '繁體中文'
            return '简体中文'
        },
        navStyle(){
            return `--activeColor: ${this.baseInfo.menuSelectedColor}`
        }
    },
    created(){
        this.isLogin = User.isLogin()
    },
    methods: {
        goLogin(){
            window.location.href = this.loginInfo.loginUrl || `${ Login.getLoginPrefix() }#/commonLogin`
            this.jumpNav()
        },
        goRegister(){
            window.location.href = this.loginInfo.registerUrl || `${ Login.getLoginPrefix() }#/commonRegister`
            this.jumpNav()
        },
        goSystem(){
            window.location.href = Login.getDefaultRedirect()
            this.jumpNav()
        },
        jumpNav(){
            this.$emit('changeIsShowNav',false)
        },
        onSetActive(route){
            this.routes.setActive(route)
        },
        onCloseNav(){
            this.$emit('close')
        },
        onSwitchLanguage(langCode){
            if(langCode === LanguageContent.getPaaSJsonSuffix()){
                return
            }
            const isReload = true
            Header.switchLanguage(langCode, isReload)
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/layout/m-header/nav-list/index.vue